import { Box, Dialog, Grid, IconButton, LinearProgress, Typography } from '@mui/material';
import { TEXT_TITLE_COLOR } from '../../constants/colors';
import useCategoryBranchController from './controller';
import { IMAGE_CATEGORY_ROOT_URL } from '../../constants/imageUrl';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import SearchNotFound from '../../components/searchNotFound';
import { MainCategoryForm } from './FormMainGroup';
import ConfirmDialog from '../../components/ConfirmDialog';
import { useTranslation } from 'react-i18next';
import { MainGroupModel } from '../../models/mainGroup';
import MainGroup from './MainGroup';
import LoadingAnimatedIcon from '../../components/loading/loadingAnimated';

const CategoryBranchView = () => {
  const { t } = useTranslation("global");
  const controller = useCategoryBranchController();

  return (
    <>
      {
        !controller.loading ?
          <>
            {
              controller.openForm ?
                <MainGroup merchantId={controller.merchant} onClose={controller.handleCloseForm} mainGroupData={controller.selectedMainGroup} />
                :
                <Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, width: '100%' }}>
                      <Typography variant="h4" fontWeight='bold' color={TEXT_TITLE_COLOR}>{t("category_page.Categories")}</Typography>
                    </Box>
                  </Box>

                  <Box mt={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%', justifyContent: 'space-between' }}>
                      <Typography variant='h5' fontWeight='bold' color={TEXT_TITLE_COLOR}>
                        Main Group ({controller.filterData.length})
                      </Typography>
                      {/* <Box>
                        <Button variant='contained' color='secondary' onClick={controller.handleOpenAddCategory} sx={{ textTransform: 'none', color: '#fff' }}>
                          <AddIcon />
                          &nbsp;
                          Create new category
                        </Button>
                      </Box> */}
                    </Box>
                  </Box>
                  <Grid container spacing={2} mt={1} sx={{ display: 'flex', flexWrap: 'wrap' }}>
                    {
                      controller.filterData.map((cat: MainGroupModel) => (
                        <Grid item xs={12} sm={6} md={3} key={cat.id} >
                          <Box sx={{
                            minHeight: 180, p: 2, borderRadius: '16px', width: 'auto', height: 'auto', boxShadow:
                              '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            background: '#f5fcff'
                          }}>
                            <Box>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <img src={IMAGE_CATEGORY_ROOT_URL + cat?.supplies_main_group_name?.icon?.url} style={{ width: '40px', height: '40px' }} alt="" />
                                <Box>
                                  <IconButton onClick={() => controller.handleOpenForm(cat?.id)}>
                                    <RemoveRedEyeIcon />
                                  </IconButton>
                                  {/* <IconButton onClick={() => controller.handleOpenDelete(cat?.id)}>
                                    <img src={Delete_IC} style={{ width: '20px', height: '20px' }} alt="" />
                                  </IconButton> */}
                                </Box>
                              </Box>
                              <Box mt={2}>
                                <Typography fontWeight='bold'>{t("category_page.Code")} : {cat?.supplies_main_group_name?.code}</Typography>
                                <Typography fontWeight='bold'>{t("category_page.English name")}: <span style={{ color: 'grey' }}>{cat?.supplies_main_group_name?.main_group_name_en}</span></Typography>
                                <Typography fontWeight='bold'>{t("category_page.Lao name")}: <span style={{ color: 'grey' }}>{cat?.supplies_main_group_name?.main_group_name_la}</span></Typography>
                              </Box>
                            </Box>
                          </Box>
                        </Grid>
                      ))
                    }
                  </Grid>
                  {
                    controller.isSearchNotFound && (
                      <SearchNotFound searchValue={controller.searchValue} />
                    )
                  }
                  <ConfirmDialog
                    open={controller.openDeleteForm}
                    title='Do you want to delete this data ?'
                    loading={controller.loadingButtonDelete}
                    onCancel={controller.handleCloseDeleteForm}
                    onConfirm={controller.handleDelete}
                  />
                  <Box>
                    <Dialog
                      fullWidth
                      maxWidth={'lg'}
                      open={controller.openMainCategory}
                    >
                      <MainCategoryForm

                        merchant={{
                          id: controller.merchant
                        }}
                        onClose={controller.handleCloseAddCategory}
                        onRefetchData={controller.handleRefetchData}
                        selectedMain={controller.selectedMainCategoryId}
                        dataMasterMainGroup={controller.dataMasterMainGroup}
                      />
                    </Dialog>
                  </Box>
                </Box>
            }
          </>

          :
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <LoadingAnimatedIcon />
          </Box>
      }
    </>
  );
};
export default CategoryBranchView;